'use client';

import React, { useEffect } from "react";
import { usePathname } from "next/navigation";

const IntercomClientComponent: React.FC = () => {
  const pathname = usePathname();

  useEffect(() => {
    // to not load the chatbot in the Sanity studio pages
    if (pathname.includes("/studio")) return;

    const intercomSettings: any = {
      api_base: "https://api-iam.intercom.io",
      app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID
    };

    // @ts-ignore
    window.intercomSettings = intercomSettings;

    // @ts-ignore
    if (window.Intercom) {
      // @ts-ignore
      window.Intercom('reattach_activator');
      // @ts-ignore
      window.Intercom('update', intercomSettings);
    } else {
      const intercomScript = document.createElement('script');
      if (!intercomScript) {
        console.error('Intercom script could not be created.');
        return
      }
      intercomScript.type = 'text/javascript';
      intercomScript.async = true;
      intercomScript.src = `https://widget.intercom.io/widget/${process.env.NEXT_PUBLIC_INTERCOM_APP_ID}`; // Ensure this matches your Intercom app ID.
      // @ts-ignore
      intercomScript.onload = () => window.Intercom('update', intercomSettings);
      document.body.appendChild(intercomScript);
    }
  }, [pathname]);
  return null; // This component does not render anything visually.
};

export default IntercomClientComponent;